import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

// FIX: Cannot find name 'document'. Access via window and cast to any for TS.
const rootElement = (window as any).document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);